<template>
  <div class="breadcrumb">
      <BaseIcon :name="icon" class="icon margin-right" />
      <ul>
          <li><router-link class="center underline" :to="'/' + mainPage.replace(/\s+/g, '-').toLowerCase()">{{ mainPage }}</router-link></li>
          <li>
            >
          </li>
          <li><router-link class="center underline" :to="'/' + subPage.replace(/\s+/g, '-').toLowerCase()">{{ subPage }}</router-link></li>
      </ul>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon
  },
  computed: {
  },
  props: {
    mainPage: String,
    subPage: String,
    icon: String
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/breadcrumbs.scss";

</style>
